import { Component, Inject } from '@angular/core';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-registration-briefly',
  // standalone: true,
  //  imports: [],
  templateUrl: './registration-briefly.component.html',
  styleUrl: './registration-briefly.component.scss'
})
export class RegistrationBrieflyComponent {
 isLoading: boolean = false;
     type;
     start_date = '';
     end_date = '';
     rep_name = '';
     off_rep_name = '';
     issue_cat = '';
     issue_date = '';
     newindetails: boolean = false;
     indetail: boolean = false;
     brfly: boolean = false;
     verybrfly: boolean = false;
     datewise: boolean = false;
     officerep: boolean = false;
     inDetailsRegReport = [];
     inDetailsRegReportTotal = {
       total_advt: 0,
       advt_total: 0,
       net_amt: 0,
       gst: 0,
       total_amt: 0,
       rcvd_amt: 0,
       pndg_amt: 0,
     };
     inDetailsOffRegReportTotal = {
       total_advt: 0,
       advt_total: 0,
       net_amt: 0,
       gst: 0,
       total_amt: 0,
       rcvd_amt: 0,
       pndg_amt: 0,
     };
     tempdata = [];
     inDetailsRegReportsubTotalData = [];
     today;
     issue_name = '';
     issueDate;
     inDetailsRegReport1: any;
     advtamt: number=0;
     advtamti: number=0;
     netadvtamt: number=0;
     netadvtamti: number=0;
     gstadvtamt: number=0;
     totaladvtamt: number=0;
     totalpendingadvtamt: number=0;
     totalgst: number=0;
     today1: string;
     issuenamewithdate: any;
     remaingtotal: number=0;
     jamatotal: number=0;
     inDetailsbriflydata: any;
     advtamtb: number=0;
     netadvtamtb: number=0;
     jamatotalb: number=0;
     jamatotalc: number=0;
     remaingtotalb:number=0;
     inDetailsoff_repdata: any;
     inDetailsoff_repdatab: any;
     inDetailsRegReportrep: any;
     beforegst_amt: number;
     totalbeforegst_amt: number;
     totaldisc_total: number;
     totalbefore_gst: any;
     inDetailsRegReportbtoff: any;
     total_pending: any;
     inDetailsRegReportdatewise: any;
     showindetail: boolean = false;
     showindetaildatewise: boolean = false;
     showoffdatewise: boolean = false;
     showdatewisevrybrfly: boolean = false;
     showoffrepvrybrfly: boolean = false;
     showindetailoffrep: boolean = false;
     show: boolean;
     totaladvtamtB :number;
     issuedatepp :any;

   
   
     constructor(
       private dialogref: MatDialogRef<RegistrationBrieflyComponent>,
       private datePipe: DatePipe,
       @Inject(MAT_DIALOG_DATA) public data: any,
       private service: DigisubservicesService
     ) {}
     newissuedatepp:any
     ngOnInit(): void {
       
     debugger
       this.type = this.data['type'];
       this.start_date = this.data['startDate'];
       this.end_date = this.data['endDate'];
       this.rep_name = this.data['rep_name'];
       this.off_rep_name = this.data['off_rep_name'];
       this.newissuedatepp=this.data['newissuedatepp']
       this.issuedatepp=this.data['issuedatepp']
       debugger
       this.issue_cat =
         this.data['issue_cat'] === undefined ? '' : this.data['issue_cat'];
         debugger
       this.issue_date =
         this.data['issueDates'] === undefined ? '' : this.data['issueDates'];      
       console.log(this.data);
       this.issueDate = this.issue_date + '';
       this.issue_name =
         this.issueDate.split(',')[0] == 'all'
           ? this.issueDate.split(',')[2]
           : this.issueDate.split(',')[1];
       this.issueDate =
         this.issueDate.split(',')[0] == 'all'
           ? this.issueDate.split(',')[1]
           : this.issueDate.split(',')[0];
       this.issueDate = new Date(
         `${this.issueDate.split('/')[1]}/${this.issueDate.split('/')[0]}/${
           this.issueDate.split('/')[2]
         }`
       );
       this.today = new Date();
       this.today1 = this.datePipe.transform(this.today, 'dd-MM-yyyy');
   
   debugger
         if (this.type === 'In Detail') {
           this.indetail = true;
           if (this.off_rep_name !== '') {
             this.officerep = true;
           }
         } else if (this.type === 'Briefly') {
           this.brfly = true;
         } else if (this.type === 'Very Briefly') {
           this.verybrfly = true;
           if (this.off_rep_name !== '') {
             this.officerep = true;
           }
         } else if (this.type === 'Datewise') {
           this.datewise = true;
           this.verybrfly = true;
         }
      
       if (this.indetail && this.datewise && !this.officerep) {
         this.inDetailsDatewise();
       } else if (this.datewise && this.verybrfly) {
         this.datewiseVeryBriefly();
       } else if (this.indetail && this.officerep && !this.datewise) {
         this.inDetailsOffRep();
       } else if (this.brfly && this.officerep) {
         // this.inDetails();
       } else if (this.indetail && !this.datewise && !this.officerep) {
         this.inDetails();
       } else if (this.verybrfly && this.officerep) {
         this.offrepVeryBriefly();
       }else{
         this.getReportData()
       }
     }
      getRegReportData() {
       throw new Error('Method not implemented.');
     }
   
     // exportexcel(fileName): void {
     //   /* table id is passed over here */
     //   let element = document.getElementById('excel-table');
     //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
   
     //   /* generate workbook and add the worksheet */
     //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
     //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
   
     //   /* save to file */
     //   XLSX.writeFile(wb, fileName + '.xlsx');
     // }
   
   
     exportexcel(fileName): void {
       console.log('Export function called with fileName:', fileName);
       
       let element = document.getElementById('print-section');
       console.log('Element found:', element);
       
       if (!element) {
         console.error('Element with ID "print-section" not found in DOM');
         return;
       }
       
       try {
         const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
         console.log('Worksheet created:', ws);
         
         const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
         
         XLSX.writeFile(wb, fileName + '.xlsx');
         console.log('File should be downloaded');
       } catch (error) {
         console.error('Error during export:', error);
       }
     }
     
     filteredinDetailsRegReport;
     addFilters() {
      
       // console.log('call addFilters');
   
       if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name != '' &&
         this.off_rep_name != '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             this.rep_name.includes(a['rep_name']) &&
             this.off_rep_name.includes(a['off_rep_name']) &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         console.log(this.filteredinDetailsRegReport,"kjl");
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name == '' &&
         this.off_rep_name != '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         console.log('excluded repname Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             this.off_rep_name.includes(a['off_rep_name']) &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name != '' &&
         this.off_rep_name == '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('excluded offrepname Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             this.rep_name.includes(a['rep_name']) &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name != '' &&
         this.off_rep_name != '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('excluded offrepname Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             this.rep_name.includes(a['rep_name']) &&
             this.off_rep_name.includes(a['off_rep_name'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name == '' &&
         this.off_rep_name == '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('excluded repname and offrepname Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name == '' &&
         this.off_rep_name != '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             this.off_rep_name.includes(a['off_rep_name'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name != '' &&
         this.off_rep_name == '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date &&
             this.rep_name.includes(a['rep_name'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date != '' &&
         this.end_date != '' &&
         this.rep_name == '' &&
         this.off_rep_name == '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         console.log('just datewise Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['booking_date'] >= this.start_date &&
             a['booking_date'] <= this.end_date
           );
         });
         console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name != '' &&
         this.off_rep_name != '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             this.rep_name.includes(a['rep_name']) &&
             this.off_rep_name.includes(a['off_rep_name']) &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name == '' &&
         this.off_rep_name != '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             this.off_rep_name.includes(a['off_rep_name']) &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name != '' &&
         this.off_rep_name == '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             this.rep_name.includes(a['rep_name']) &&
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name != '' &&
         this.off_rep_name != '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             this.rep_name.includes(a['rep_name']) &&
             this.off_rep_name.includes(a['off_rep_name'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name == '' &&
         this.off_rep_name == '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name == '' &&
         this.off_rep_name != '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return this.off_rep_name.includes(a['off_rep_name']);
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name != '' &&
         this.off_rep_name == '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return this.rep_name.includes(a['rep_name']);
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name == '' &&
         this.off_rep_name != '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return this.off_rep_name.includes(a['off_rep_name']);
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name == '' &&
         this.off_rep_name == '' &&
         this.issue_cat != '' &&
         this.issue_date != ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
           return (
             a['issuename'] === this.issue_cat &&
             this.issue_date.includes(a['issue_date'])
           );
         });
         // console.log(this.filteredinDetailsRegReport);
       } else if (
         this.start_date == '' &&
         this.end_date == '' &&
         this.rep_name == '' &&
         this.off_rep_name == '' &&
         this.issue_cat == '' &&
         this.issue_date == ''
       ) {
         // console.log('all Filters');
         this.filteredinDetailsRegReport = this.inDetailsRegReport;
         // console.log(this.filteredinDetailsRegReport);
       }
       console.log(this.filteredinDetailsRegReport);
       this.filtersCalculateData();
     }
   
     // filtersCalculateData() {
     //   this.inDetailsRegReportTotal.total_advt =
     //     this.filteredinDetailsRegReport.length;
     //   for (
     //     let index = 0;
     //     index < this.filteredinDetailsRegReport.length;
     //     index++
     //   ) {
     //     this.inDetailsRegReportTotal.net_amt += parseFloat(
     //       this.filteredinDetailsRegReport[index]['total_amount']
     //     );
     //     this.inDetailsRegReportTotal.advt_total += parseFloat(
     //       this.filteredinDetailsRegReport[index]['advt_amt']
     //     );
     //     this.inDetailsRegReportTotal.gst += parseFloat(
     //       this.filteredinDetailsRegReport[index]['sgst']
     //     );
     //     this.inDetailsRegReportTotal.gst += parseFloat(
     //       this.filteredinDetailsRegReport[index]['cgst']
     //     );
     //     this.inDetailsRegReportTotal.total_amt += parseFloat(
     //       this.filteredinDetailsRegReport[index]['amount']
     //     );
     //     this.inDetailsRegReportTotal.rcvd_amt += parseFloat(
     //       this.filteredinDetailsRegReport[index]['part_pymt_amt']
     //     );
     //     this.inDetailsRegReportTotal.pndg_amt += parseFloat(
     //       this.filteredinDetailsRegReport[index]['part_pymt_remaning_amt']
     //     );
     //   }
     // }
   
    filtersCalculateData() {
     // Reset all totals before calculation
     this.inDetailsRegReportTotal = {
       total_advt: 0,
       net_amt: 0,
       advt_total: 0,
       gst: 0,
       total_amt: 0,
       rcvd_amt: 0,
       pndg_amt: 0
     };
   
     this.inDetailsRegReportTotal.total_advt = this.filteredinDetailsRegReport.length;
   
     for (let index = 0; index < this.filteredinDetailsRegReport.length; index++) {
       const row = this.filteredinDetailsRegReport[index];
   
       this.inDetailsRegReportTotal.net_amt += parseFloat(row['total_amount'] || 0);
       this.inDetailsRegReportTotal.advt_total += parseFloat(row['advt_amt'] || 0);
       this.inDetailsRegReportTotal.gst += parseFloat(row['sgst'] || 0);
       this.inDetailsRegReportTotal.gst += parseFloat(row['cgst'] || 0);
       this.inDetailsRegReportTotal.total_amt += parseFloat(row['amount'] || 0);
       // this.inDetailsRegReportTotal.rcvd_amt += parseFloat(row['part_pymt_amt'] || 0);
       this.inDetailsRegReportTotal.pndg_amt += parseFloat(row['part_pymt_remaning_amt'] || 0);
     }
   }
   
     
   
     getReportData() {
       
       const req1:any = {
      
         "start_date":this.start_date,
         "end_date":this.end_date,
         "rep_name" : this.rep_name,
         "off_rep_name":this.off_rep_name,
         "issuename":this.issue_cat,
         "issue_date" : this.issue_date
       }
       
       this.service.getRegReportInDetails1(req1).subscribe((data) => {
     debugger
     this.inDetailsRegReport = data;
     this.inDetailsRegReport1 = data;
     this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
     console.log(this.inDetailsRegReport1, "reg report")
     
     // Move all initializations here, inside the subscription
     this.advtamti = 0;
     this.netadvtamti = 0;
     this.gstadvtamt = 0;
     this.totaladvtamt = 0;
     this.totalgst = 0;
     this.remaingtotal = 0;
     this.totalpendingadvtamt = 0;
     this.jamatotalc = 0;
     this.totalbeforegst_amt = 0;
     this.totaldisc_total = 0;
     
     for(let data1 of this.inDetailsRegReport1){
       debugger;
       this.advtamti += parseFloat(data1.advt_amt) || 0;
       this.netadvtamti += parseFloat(data1.amount) || 0;
       this.totaladvtamt += parseFloat(data1.amount) || 0;
       this.remaingtotal += parseFloat(data1.remaingamt) || 0;
       this.totalbeforegst_amt += parseFloat(data1.total_amount) || 0;
       this.jamatotalc += parseFloat(data1.pymt_rcv_amt) || 0;
       this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
       this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
       
       data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
       this.totalgst += parseFloat(data1.totalgst)
     }
     
     console.log(this.totalbeforegst_amt, "before gst")
     console.log(this.inDetailsRegReport, "indeatils");
     this.addFilters();
     this.getReportDatewise();
   });
   
   // off indetails
   this.service.getRegReportInDetailsoff(req1).subscribe((data) => {
     this.inDetailsRegReport = data;
     this.inDetailsRegReportbtoff = data;
     this.inDetailsRegReport1 = data; // ✅ You were missing this line
   
     this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
   
     console.log(this.inDetailsRegReport1, "reg report");
   
     this.advtamt = 0;
     this.netadvtamt = 0;
     this.gstadvtamt = 0;
     this.totaladvtamt = 0;
     this.totalgst = 0;
     this.remaingtotal = 0;
     this.totalpendingadvtamt = 0;
     this.jamatotal = 0;
     this.totalbeforegst_amt = 0;
     this.totaldisc_total = 0;
   
     for (let data1 of this.inDetailsRegReport1) {
       debugger;
       this.advtamt += parseFloat(data1.advt_amt) || 0;
       this.netadvtamt += parseFloat(data1.total_amount) || 0;
       this.totaladvtamt += parseFloat(data1.amount) || 0;
       this.remaingtotal += parseFloat(data1.remaingamt) || 0;
       this.totalbeforegst_amt += parseFloat(data1.beforegst_amt) || 0;
       this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
       this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
   
       this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
       data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst);
       this.totalgst += parseFloat(data1.totalgst) || 0;
     }
   
     console.log(this.advtamt, "advt total");
     console.log(this.inDetailsRegReport, "indeatils");
   
     this.addFilters();
     this.getReportDatewise();
   });
   
   
       this.service.getRegReportBriefly(req1).subscribe((data) => {
         this.inDetailsRegReport = data;
         this.inDetailsbriflydata = data;
         
   
         this.advtamtb =0;
         this.netadvtamtb=0;
         this.gstadvtamt=0;
         this.totaladvtamtB =0;
         this.totalgst =0;
         this.remaingtotalb = 0;
         this.totalpendingadvtamt=0;
         this.jamatotalb =0;
         for(let data1 of this.inDetailsbriflydata){
           debugger;
           this.advtamtb += parseFloat(data1.advt_amt) || 0;
           this.netadvtamtb += parseFloat(data1.total_amount) || 0;
           debugger;
           this.totaladvtamtB += parseFloat(data1.amount) || 0;
           // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
           this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
           this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
           
           this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
           // this.totalgst += parseFloat(data1.gst)
           this.totalgst +=  parseFloat(data1.gst)
         }
   
         console.log(this.inDetailsRegReport, "indeatils");
         this.addFilters();
         this.getReportDatewise();
         
         // this.getReportDatewise();
       });
   
       this.service.getRegReportOff_rep(req1).subscribe((data) => {
         this.inDetailsRegReport = data;
         this.inDetailsoff_repdata = data;
         
   
         this.advtamtb =0;
         this.netadvtamtb=0;
         this.gstadvtamt=0;
         this.totaladvtamt=0;
         this.totalgst =0;
         this.remaingtotalb = 0;
         this.totalpendingadvtamt=0;
         this.jamatotalb =0;
         for(let data1 of this.inDetailsoff_repdata){
          
           this.advtamtb += parseFloat(data1.advt_amt) || 0;
           this.netadvtamtb += parseFloat(data1.amount) || 0;
           this.totaladvtamt += parseFloat(data1.amount) || 0;
           // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
           this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
           // this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
           
           this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
           // this.totalgst += parseFloat(data1.gst)
           this.totalgst +=  parseFloat(data1.gst)
           for(let data2 of data1.advt_data){
             debugger;
             this.jamatotalb += parseFloat(data2.rcv_amt) || 0;
           }
         }
   
         console.log(this.inDetailsRegReport, "indeatils");
         this.addFilters();
         this.getReportDatewise();
         
         // this.getReportDatewise();
       });
   
       this.service.getRegReportOff_repb(req1).subscribe((data) => {
         this.inDetailsRegReport = data;
         this.inDetailsoff_repdatab = data;
         
   
         this.advtamtb =0;
         this.netadvtamtb=0;
         this.gstadvtamt=0;
         this.totaladvtamt=0;
         this.totalgst =0;
         this.remaingtotalb = 0;
         this.totalpendingadvtamt=0;
         this.jamatotalb =0;
         for(let data1 of this.inDetailsbriflydata){
           debugger;
           this.advtamtb += parseFloat(data1.advt_amt) || 0;
           this.netadvtamtb += parseFloat(data1.amount) || 0;
           this.totaladvtamt += parseFloat(data1.amount) || 0;
           // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
           this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
           this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
           
           this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
           // this.totalgst += parseFloat(data1.gst)
           this.totalgst +=  parseFloat(data1.gst)
         }
   
         console.log(this.inDetailsRegReport, "indeatils");
         this.addFilters();
         this.getReportDatewise();
         
         // this.getReportDatewise();
       });
   
       this.service.getRegReportInDetailsrep(req1).subscribe((data) => {
         this.inDetailsRegReport = data;
         this.inDetailsRegReportrep = data;
         this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
         // console.log(this.inDetailsRegReport1,  "reg report")
   
         this.advtamt =0;
         this.netadvtamt=0;
         this.gstadvtamt=0;
         this.totaladvtamt=0;
         this.totalgst =0;
         this.remaingtotal = 0;
         this.totalpendingadvtamt=0;
         this.jamatotal =0;
         this.totaldisc_total =0;
         this.totalbefore_gst =0;
         this.total_pending =0 
         for(let data2 of this.inDetailsRegReportrep){
           for(let data1 of data2.advt_data){
             this.advtamt += parseFloat(data1.advt_amt) || 0;
             this.netadvtamt += parseFloat(data1.total_amount) || 0;
             this.totaladvtamt += parseFloat(data1.amount) || 0;
             // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
             this.remaingtotal += parseFloat(data1.remaingamt) || 0;
             this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
             this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
             this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;    
             this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
             data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
             this.totalgst +=  parseFloat(data1.totalgst) || 0;
             this.total_pending += parseFloat(data1.remaining_amt)
           }
          
         }
   
         console.log(this.total_pending, "total_pending");
         this.addFilters();
         this.getReportDatewise();
         
         // this.getReportDatewise();
       });
   
       this.service.getRegReportInDetailsdatewise(req1).subscribe((data) => {
         this.inDetailsRegReport = data;
         this.inDetailsRegReportdatewise = data;
         this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
         // console.log(this.inDetailsRegReport1,  "reg report")
   
         this.advtamt =0;
         this.netadvtamt=0;
         this.gstadvtamt=0;
         this.totaladvtamt=0;
         this.totalgst =0;
         this.remaingtotal = 0;
         this.totalpendingadvtamt=0;
         this.jamatotal =0;
         this.totaldisc_total =0;
         this.totalbefore_gst =0;
         this.total_pending =0 
         for(let data2 of this.inDetailsRegReportrep){
           for(let data1 of data2.advt_data){
             this.advtamt += parseFloat(data1.advt_amt) || 0;
             this.netadvtamt += parseFloat(data1.total_amount) || 0;
             this.totaladvtamt += parseFloat(data1.amount) || 0;
             // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
             this.remaingtotal += parseFloat(data1.remaingamt) || 0;
             this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
             this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
             this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;    
             this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
             data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
             this.totalgst +=  parseFloat(data1.totalgst) || 0;
             this.total_pending += parseFloat(data1.remaining_amt)
           }
          
         }
   
         console.log(this.inDetailsRegReportdatewise, "inDetailsRegReportdatewise");
         this.addFilters();
         this.getReportDatewise();
         
         // this.getReportDatewise();
       });
     }
   
     getReportDatewise() {
       
       if (this.filteredinDetailsRegReport.length > 0) {
         this.tempdata = this.uniqueId(
           this.filteredinDetailsRegReport,
           (a) => a.booking_date
         );
         // console.log('why', tempData);
         for (let index = 0; index < this.tempdata.length; index++) {
           let arr = this.filteredinDetailsRegReport.filter((a) => {
             return a.booking_date == this.tempdata[index]['booking_date'];
           });
   
           let inDetailsRegReportsubTotal = {
             total_advt: 0,
             advt_total: 0,
             net_amt: 0,
             gst: 0,
             total_amt: 0,
             rcvd_amt: 0,
             pndg_amt: 0,
           };
   
           inDetailsRegReportsubTotal.total_advt = arr.length;
           debugger
           for (let index = 0; index < arr.length; index++) {
             inDetailsRegReportsubTotal.net_amt += parseFloat(
               arr[index]['total_amount']
             );
             inDetailsRegReportsubTotal.advt_total += parseFloat(
               arr[index]['advt_amt']
             );
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
             inDetailsRegReportsubTotal.total_amt += parseFloat(
               arr[index]['amount']
             );
             inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
               arr[index]['part_pymt_amt']
             );
             inDetailsRegReportsubTotal.pndg_amt += parseFloat(
               arr[index]['part_pymt_remaning_amt']
             );
           }
           arr.push(inDetailsRegReportsubTotal);
           this.inDetailsRegReportsubTotalData.push(arr);
           console.log( this.inDetailsRegReportsubTotalData, "abc")
         }
       }
     }
   
     inDetails() {
       console.log('inDetails');
       this.getReportData();
     }
   
     inDetailsDatewise() {
       console.log('inDetailsDatewise');
       this.getReportData();
       // setTimeout(() => {
         this.getReportDatewise();
       // }, 200);
     }
   
     offrepVeryBriefly() {
       console.log('offrepVeryBriefly');
       this.getReportData();
       setTimeout(() => {
         this.getReportOffRepVeryBriefly();
       }, 200);
     }
   
     datewiseVeryBriefly() {
       this.getReportData();
       setTimeout(() => {
         this.getReportDatewiseVeryBriefly();
       }, 200);
     }
   
     inDetailsOffRep() {
       this.getReportData();
       setTimeout(() => {
         this.getReportInDetailOffRep();
       }, 200);
     }
   
     uniqueId(data, key) {
       return [...new Map(data.map((x) => [key(x), x])).values()];
     }
   
     toInt(no) {
       return parseFloat(no);
     }
   
     getReportDatewiseVeryBriefly() {
       if (this.inDetailsRegReport.length > 0) {
         this.tempdata = this.uniqueId(
           this.inDetailsRegReport,
           (a) => a.booking_date
         );
         // console.log('why', tempData);
         for (let index = 0; index < this.tempdata.length; index++) {
           let arr = this.inDetailsRegReport.filter((a) => {
             return a.booking_date == this.tempdata[index]['booking_date'];
           });
   
           let inDetailsRegReportsubTotal = {
             date: '',
             total_advt: 0,
             advt_total: 0,
             net_amt: 0,
             gst: 0,
             total_amt: 0,
             rcvd_amt: 0,
             pndg_amt: 0,
           };
   
           inDetailsRegReportsubTotal.total_advt = arr.length;
           inDetailsRegReportsubTotal.date = arr[0]['booking_date'];
           for (let index = 0; index < arr.length; index++) {
             inDetailsRegReportsubTotal.net_amt += parseFloat(
               arr[index]['total_amount']
             );
             inDetailsRegReportsubTotal.advt_total += parseFloat(
               arr[index]['advt_amt']
             );
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
             inDetailsRegReportsubTotal.total_amt += parseFloat(
               arr[index]['amount']
             );
             inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
               arr[index]['part_pymt_amt']
             );
             inDetailsRegReportsubTotal.pndg_amt += parseFloat(
               arr[index]['part_pymt_remaning_amt']
             );
           }
           this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
         }
         // console.log(this.inDetailsRegReportsubTotalData);
       }
     }
   
     repData = [];
     getReportInDetailOffRep() {
       if (this.inDetailsRegReport.length > 0) {
         this.tempdata = this.inDetailsRegReport.filter((a) => {
           return this.off_rep_name.includes(a.off_rep_name);
         });
         this.calculateTotal(this.tempdata);
   
         let data = this.uniqueId(this.tempdata, (a) => a.rep_name);
   
         for (let index = 0; index < Object.keys(data).length; index++) {
           let arr = this.tempdata.filter((a) => {
             return a.rep_name == data[index]['rep_name'];
           });
   
           let inDetailsRegReportsubTotal = {
             total_advt: 0,
             advt_total: 0,
             net_amt: 0,
             gst: 0,
             total_amt: 0,
             rcvd_amt: 0,
             pndg_amt: 0,
           };
   
           inDetailsRegReportsubTotal.total_advt = arr.length;
           for (let index = 0; index < arr.length; index++) {
             inDetailsRegReportsubTotal.net_amt += parseFloat(
               arr[index]['total_amount']
             );
             inDetailsRegReportsubTotal.advt_total += parseFloat(
               arr[index]['advt_amt']
             );
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
             inDetailsRegReportsubTotal.total_amt += parseFloat(
               arr[index]['amount']
             );
             inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
               arr[index]['part_pymt_amt']
             );
             inDetailsRegReportsubTotal.pndg_amt += parseFloat(
               arr[index]['part_pymt_remaning_amt']
             );
           }
           arr.push(inDetailsRegReportsubTotal);
           this.inDetailsRegReportsubTotalData.push(arr);
         }
       }
     }
   
     calculateTotal(data) {
       this.inDetailsOffRegReportTotal.total_advt = data.length;
       for (let index = 0; index < data.length; index++) {
         this.inDetailsOffRegReportTotal.net_amt += parseFloat(
           data[index]['total_amount']
         );
         this.inDetailsOffRegReportTotal.advt_total += parseFloat(
           data[index]['advt_amt']
         );
         this.inDetailsOffRegReportTotal.gst += parseFloat(data[index]['sgst']);
         this.inDetailsOffRegReportTotal.gst += parseFloat(data[index]['cgst']);
         this.inDetailsOffRegReportTotal.total_amt += parseFloat(
           data[index]['amount']
         );
         this.inDetailsOffRegReportTotal.rcvd_amt += parseFloat(
           data[index]['part_pymt_amt']
         );
         this.inDetailsOffRegReportTotal.pndg_amt += parseFloat(
           data[index]['part_pymt_remaning_amt']
         );
       }
     }
   
     getReportOffRepVeryBriefly() {
       if (this.inDetailsRegReport.length > 0) {
         this.tempdata = this.inDetailsRegReport.filter((a) => {
           return this.off_rep_name.includes(a.off_rep_name);
         });
         this.calculateTotal(this.tempdata);
   
         let data = this.uniqueId(this.tempdata, (a) => a.rep_name);
   
         for (let index = 0; index < Object.keys(data).length; index++) {
           let arr = this.tempdata.filter((a) => {
             return a.rep_name == data[index]['rep_name'];
           });
   
           let inDetailsRegReportsubTotal = {
             off_rep_name: '',
             rep_name: '',
             total_advt: 0,
             advt_total: 0,
             net_amt: 0,
             gst: 0,
             total_amt: 0,
             rcvd_amt: 0,
             pndg_amt: 0,
           };
   
           inDetailsRegReportsubTotal.total_advt = arr.length;
           for (let index = 0; index < arr.length; index++) {
             inDetailsRegReportsubTotal.off_rep_name = arr[index]['off_rep_name'];
             inDetailsRegReportsubTotal.rep_name = arr[index]['rep_name'];
             inDetailsRegReportsubTotal.net_amt += parseFloat(
               arr[index]['total_amount']
             );
             inDetailsRegReportsubTotal.advt_total += parseFloat(
               arr[index]['advt_amt']
             );
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
             inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
             inDetailsRegReportsubTotal.total_amt += parseFloat(
               arr[index]['amount']
             );
             inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
               arr[index]['part_pymt_amt']
             );
             inDetailsRegReportsubTotal.pndg_amt += parseFloat(
               arr[index]['part_pymt_remaning_amt']
             );
           }
           // arr.push(inDetailsRegReportsubTotal);
           this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
         }
       }
     }
   
 //    printPageA4Portrait() {
 //     this.show = true;
 //     const printSection = document.getElementById('print-section');
 //     if (!printSection) {
 //         console.error("Print section not found!");
 //         return;
 //     }
   
 //     const printContent = printSection.innerHTML;
   
 //     const screenWidth = window.screen.availWidth;
 //     const windowWidth = 1000; // Smaller window for portrait
 //     const leftPosition = screenWidth - windowWidth - 50;
   
 //     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
   
 //     if (printWindow) {
 //         printWindow.document.open();
 //         printWindow.document.write(`
 //             <html>
 //                 <head>
 //                     <title>Print Report</title>
 //                     <style>
 //                         @media print {
 //                             @page {
 //                                 size: A4 portrait;
 //                                 margin: 5mm;
 //                             }
 //                             body {
 //                                 font-family: Arial, sans-serif;
 //                                 margin: 0;
 //                                 padding: 0;
 //                                 font-size: 9px !important;
 //                             }
 //                             .print-section {
 //                                 width: 100%;
 //                                 margin: 0 auto;
 //                                 padding: 0;
 //                             }
 //                             table {
 //                                 width: 100% !important;
 //                                 border-collapse: collapse;
 //                                 table-layout: auto;
 //                                 page-break-inside: auto;
 //                                 border: 1px solid black !important;
 //                             }
 //                             tr {
 //                                 page-break-inside: avoid;
 //                                 page-break-after: auto;
 //                             }
 //                             th, td {
 //                                 padding: 2px 3px !important;
 //                                 border: 1px solid black !important;
 //                                 font-size: 9px;
 //                                 line-height: 1.2;
 //                                 word-wrap: break-word;
 //                                 overflow-wrap: break-word;
 //                             }
 //                             th {
 //                                 background-color: #f2f2f2;
 //                                 font-weight: bold;
 //                             }
 //                             tr {
 //                                 border-bottom: 1px solid black !important;
 //                             }
 //                             tr.header-row {
 //                                 display: table-header-group;
 //                             }
 //                             td:nth-child(1) {
 //                                 width: 1%;
 //                                 text-align: left !important;
 //                                 border-left: 1px solid black !important;
 //                             }
 //                             td:nth-child(2),
 //                             td:nth-child(3),
 //                             td:nth-child(4),
 //                             td:nth-child(5),
 //                             td:nth-child(6),
 //                             td:nth-child(8) {
 //                                 text-align: left !important;
 //                             }
 //                             td:nth-child(5) {
 //                                 width: 5%;
 //                                 white-space: normal;
 //                             }
 //                             td.advt-name {
 //                                 max-width: 120px; /* Reduced for portrait */
 //                                 white-space: nowrap;
 //                                 overflow: hidden;
 //                                 text-overflow: ellipsis;
 //                             }
 //                             td:nth-child(n+12),
 //                             td.amount,
 //                             td[data-type="number"] {
 //                                 text-align: right !important;
 //                             }
 //                             td.text,
 //                             td[data-type="string"] {
 //                                 text-align: left !important;
 //                             }
 //                             .br-right { border-right: 1px solid black !important; }
 //                             .br-rightt { border-right: 4px solid black !important; }
 //                             .br-bottom { border-bottom: 2px solid black !important; }
 //                             .br-top { border-top: 2px solid black !important; }
 //                             .noPrint { display: none !important; }
 //                             .footer-line {
 //                                 position: fixed;
 //                                 bottom: 0;
 //                                 left: 0;
 //                                 width: 100%;
 //                                 height: 1px;
 //                                 background-color: black;
 //                             }
 //                             thead { 
 //                                 display: table-header-group; 
 //                                 border: 1px solid black !important;
 //                             }
 //                             tfoot { 
 //                                 display: table-footer-group; 
 //                                 border: 1px solid black !important;
 //                             }
 //                             td.balance-value {
 //                                 text-align: right !important;
 //                             }
 //                             /* Ensure all borders are displayed */
 //                             table, th, td {
 //                                 border-style: solid !important;
 //                                 border-width: 1px !important;
 //                                 border-color: black !important;
 //                             }
 //                             /* Make sure header repeats on each page */
 //                             thead tr {
 //                                 display: table-row !important;
 //                             }
 //                             /* Force page breaks after specific elements if needed */
 //                             .page-break {
 //                                 page-break-after: always;
 //                             }
 //                         }
 //                     </style>
 //                 </head>
 //                 <body>
 //                     <div class="print-section">
 //                         ${printContent}
 //                         <div class="footer-line"></div>
 //                     </div>
 //                     <script>
 //                        window.onload = function () {
 //     const table = document.querySelector('table');
 //     if (!table) {
 //         console.error("Table not found");
 //         return;
 //     }
 
 //     let headerRowIndex = -1;
 //     const maxRowsToCheck = Math.min(10, table.rows.length);
 
 //     // Find header row with column names
 //     for (let i = 0; i < maxRowsToCheck; i++) {
 //         const row = table.rows[i];
 //         const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
 
 //         if (row.cells.length >= 8 &&
 //             (cellTexts.includes('Invoice No') ||
 //              cellTexts.includes('Receipt No') ||
 //              cellTexts.includes('Balance'))) {
 //             headerRowIndex = i;
 //             break;
 //         }
 //     }
 
 //     if (headerRowIndex >= 0) {
 //         // Create thead and move only the actual header row into it
 //         let thead = table.querySelector('thead');
 //         if (!thead) {
 //             thead = document.createElement('thead');
 //             table.insertBefore(thead, table.firstChild);
 //         }
 
 //         const headerRow = table.rows[headerRowIndex];
 //         thead.appendChild(headerRow.cloneNode(true)); // Clone the header row to preserve it
 //     }
 
 //     // Alignment processing
 //     const cells = document.querySelectorAll('td');
 //     cells.forEach(cell => {
 //         const content = cell.textContent.trim();
 
 //         if (content.includes('येणे') ||
 //             content.includes('Opening Balance') ||
 //             content.match(/^\\d+\\s+येणे$/) ||
 //             content.includes('Balance C/F') ||
 //             content.includes('Total')) {
 //             cell.style.textAlign = 'right';
 //             cell.classList.add('balance-value');
 //         }
 
 //         const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
 //         if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
 //             cell.style.textAlign = 'right';
 //             cell.classList.add('amount');
 //         }
 
 //         // Ensure all cells have borders
 //         cell.style.border = '1px solid black';
 //     });
 
 //     setTimeout(() => {
 //         window.print();
 //         setTimeout(() => { window.close(); }, 500);
 //     }, 200);
 // };
 //                     </script>
 //                 </body>
 //             </html>
 //         `);
 //         printWindow.document.close();
 //     } else {
 //         console.error("Failed to open print window.");
 //     }
 // }
   
 // printPageA4Portrait() {
 //     this.show = true;
 //     const printSection = document.getElementById('print-section');
 //     if (!printSection) {
 //         console.error("Print section not found!");
 //         return;
 //     }
   
 //     const printContent = printSection.innerHTML;
   
 //     const screenWidth = window.screen.availWidth;
 //     const windowWidth = 1000;
 //     const leftPosition = screenWidth - windowWidth - 50;
   
 //     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
   
 //     if (printWindow) {
 //         printWindow.document.open();
 //         printWindow.document.write(`
 //             <html>
 //                 <head>
 //                     <title>Print Report</title>
 //                     <style>
 //                         @media print {
 //                             @page {
 //                                 size: A3 portrait;
 //                                 margin: 5mm;
 //                             }
 //                             body {
 //                                 font-family: Arial, sans-serif;
 //                                 margin: 0;
 //                                 padding: 0;
 //                                 font-size: 14px !important;
 //                             }
 //                             .print-section {
 //                                 width: 100%;
 //                                 margin: 0 auto;
 //                                 padding: 0;
 //                             }
 //                             table {
 //                                 width: auto !important;
 //                                 border-collapse: collapse;
 //                                 table-layout: auto;
 //                                 page-break-inside: auto;
 //                                 border: 1px solid black !important;
 //                             }
 //                             tr {
 //                                 page-break-inside: avoid;
 //                                 page-break-after: auto;
 //                             }
 //                             th, td {
 //                                 padding: 2px 3px !important;
 //                                 border: 1px solid black !important;
 //                                 font-size: 14px;
 //                                 line-height: 1.2;
 //                                 white-space: nowrap;
 //                             }
 //                             th {
 //                                 background-color: #f2f2f2;
 //                                 font-weight: bold;
 //                             }
 //                             tr {
 //                                 border-bottom: 1px solid black !important;
 //                             }
 //                             tr.header-row {
 //                                 display: table-header-group;
 //                             }
 //                             td[data-type="number"],
 //                             td.amount,
 //                             td.balance-value,
 //                             td:nth-child(n+12) {
 //                                 text-align: right !important;
 //                             }
 //                             td.text,
 //                             td[data-type="string"] {
 //                                 text-align: left !important;
 //                             }
 //                             .br-right { border-right: 1px solid black !important; }
 //                             .br-rightt { border-right: 4px solid black !important; }
 //                             .br-bottom { border-bottom: 2px solid black !important; }
 //                             .br-top { border-top: 2px solid black !important; }
 //                             .noPrint { display: none !important; }
 //                             .footer-line {
 //                                 position: fixed;
 //                                 bottom: 0;
 //                                 left: 0;
 //                                 width: 100%;
 //                                 height: 1px;
 //                                 background-color: black;
 //                             }
 //                             thead { 
 //                                 display: table-header-group; 
 //                                 border: 1px solid black !important;
 //                             }
 //                             tfoot { 
 //                                 display: table-footer-group; 
 //                                 border: 1px solid black !important;
 //                             }
 //                             /* Ensure all borders are displayed */
 //                             table, th, td {
 //                                 border-style: solid !important;
 //                                 border-width: 1px !important;
 //                                 border-color: black !important;
 //                             }
 //                             /* Make sure header repeats on each page */
 //                             thead tr {
 //                                 display: table-row !important;
 //                             }
 //                         }
 //                     </style>
 //                 </head>
 //                 <body>
 //                     <div class="print-section">
 //                         ${printContent}
 //                         <div class="footer-line"></div>
 //                     </div>
 //                     <script>
 //                        window.onload = function () {
 //                            const table = document.querySelector('table');
 //                            if (!table) {
 //                                console.error("Table not found");
 //                                return;
 //                            }
 
 //                            // Auto-size columns based on content
 //                            table.style.width = 'auto';
 //                            const cols = table.querySelectorAll('td, th');
 //                            cols.forEach(cell => {
 //                                cell.style.width = 'auto';
 //                                cell.style.whiteSpace = 'nowrap';
 //                            });
 
 //                            let headerRowIndex = -1;
 //                            const maxRowsToCheck = Math.min(10, table.rows.length);
 
 //                            // Find header row with column names
 //                            for (let i = 0; i < maxRowsToCheck; i++) {
 //                                const row = table.rows[i];
 //                                const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
 
 //                                if (row.cells.length >= 8 &&
 //                                    (cellTexts.includes('Invoice No') ||
 //                                     cellTexts.includes('Receipt No') ||
 //                                     cellTexts.includes('Balance'))) {
 //                                    headerRowIndex = i;
 //                                    break;
 //                                }
 //                            }
 
 //                            if (headerRowIndex >= 0) {
 //                                // Create thead and move only the actual header row into it
 //                                let thead = table.querySelector('thead');
 //                                if (!thead) {
 //                                    thead = document.createElement('thead');
 //                                    table.insertBefore(thead, table.firstChild);
 //                                }
 
 //                                const headerRow = table.rows[headerRowIndex];
 //                                thead.appendChild(headerRow.cloneNode(true));
 //                            }
 
 //                            // Alignment processing
 //                            const cells = document.querySelectorAll('td');
 //                            cells.forEach(cell => {
 //                                const content = cell.textContent.trim();
 
 //                                if (content.includes('येणे') ||
 //                                    content.includes('Opening Balance') ||
 //                                    content.match(/^\\d+\\s+येणे$/) ||
 //                                    content.includes('Balance C/F') ||
 //                                    content.includes('Total')) {
 //                                    cell.style.textAlign = 'right';
 //                                    cell.classList.add('balance-value');
 //                                }
 
 //                                const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
 //                                if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
 //                                    cell.style.textAlign = 'right';
 //                                    cell.classList.add('amount');
 //                                }
 
 //                                cell.style.border = '1px solid black';
 //                            });
 
 //                            setTimeout(() => {
 //                                window.print();
 //                                setTimeout(() => { window.close(); }, 500);
 //                            }, 200);
 //                        };
 //                     </script>
 //                 </body>
 //             </html>
 //         `);
 //         printWindow.document.close();
 //     } else {
 //         console.error("Failed to open print window.");
 //     }
 // }
 
   printPageA4Portrait() {
 
           this.show = true;
           const printSection = document.getElementById('print-section');
           if (!printSection) {
               console.error("Print section not found!");
               return;
           }
         
           const printContent = printSection.innerHTML;
         
           const screenWidth = window.screen.availWidth;
           const windowWidth = 1000;
           const leftPosition = screenWidth - windowWidth - 50;
         
           const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
         
           if (printWindow) {
               printWindow.document.open();
               printWindow.document.write(`
                   <html>
                       <head>
                           <title>Print Report</title>
                           <style>
                               @media print {
                                   @page {
                                       size: A4 portrait;
                                       margin: 5mm;
                                   }
                                   body {
                                       font-family: Arial, sans-serif;
                                       margin: 0;
                                       padding: 0;
                                       font-size: 9px !important;
                                   }
                                   .print-section {
                                       width: 100%;
                                       margin: 0 auto;
                                       padding: 0;
                                   }
                                   table {
                                       width: auto !important;
                                       border-collapse: collapse;
                                       table-layout: auto;
                                       page-break-inside: auto;
                                       border: 1px solid black !important;
                                   }
                                   tr {
                                       page-break-inside: avoid;
                                       page-break-after: auto;
                                   }
                                   th, td {
                                       padding: 2px 3px !important;
                                       border: 1px solid black !important;
                                       font-size: 9px;
                                       line-height: 1.2;
                                       white-space: nowrap;
                                   }
                                   th {
                                       background-color: #f2f2f2;
                                       font-weight: bold;
                                   }
                                   tr {
                                       border-bottom: 1px solid black !important;
                                   }
                                   tr.header-row {
                                       display: table-header-group;
                                   }
                                   td[data-type="number"],
                                   td.amount,
                                   td.balance-value,
                                   td:nth-child(n+12) {
                                       text-align: right !important;
                                   }
                                   td.text,
                                   td[data-type="string"] {
                                       text-align: left !important;
                                   }
                                   .br-right { border-right: 1px solid black !important; }
                                   .br-rightt { border-right: 4px solid black !important; }
                                   .br-bottom { border-bottom: 1px solid black !important; }
                                   .br-top { border-top: 1px solid black !important; }
                                   .noPrint { display: none !important; }
                                   .footer-line {
                                       position: fixed;
                                       bottom: 0;
                                       left: 0;
                                       width: 100%;
                                       height: 1px;
                                       background-color: black;
                                   }
                                   thead { 
                                       display: table-header-group; 
                                       border: 1px solid black !important;
                                   }
                                   tfoot { 
                                       display: table-footer-group; 
                                       border: 1px solid black !important;
                                   }
                                   /* Ensure all borders are displayed */
                                   table, th, td {
                                       border-style: solid !important;
                                       border-width: 1px !important;
                                       border-color: black !important;
                                   }
                                   /* Make sure header repeats on each page */
                                   thead tr {
                                       display: table-row !important;
                                   }
                               }
                           </style>
                       </head>
                       <body>
                           <div class="print-section">
                               ${printContent}
                               <div class="footer-line"></div>
                           </div>
                           <script>
                              window.onload = function () {
                                  const table = document.querySelector('table');
                                  if (!table) {
                                      console.error("Table not found");
                                      return;
                                  }
       
                                  // Auto-size columns based on content
                                  table.style.width = 'auto';
                                  const cols = table.querySelectorAll('td, th');
                                  cols.forEach(cell => {
                                      cell.style.width = 'auto';
                                      cell.style.whiteSpace = 'nowrap';
                                  });
       
                                  let headerRowIndex = -1;
                                  const maxRowsToCheck = Math.min(10, table.rows.length);
       
                                  // Find header row with column names
                                  for (let i = 0; i < maxRowsToCheck; i++) {
                                      const row = table.rows[i];
                                      const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
       
                                      if (row.cells.length >= 8 &&
                                          (cellTexts.includes('Invoice No') ||
                                           cellTexts.includes('Receipt No') ||
                                           cellTexts.includes('Balance'))) {
                                          headerRowIndex = i;
                                          break;
                                      }
                                  }
       
                                  if (headerRowIndex >= 0) {
                                      // Create thead and move only the actual header row into it
                                      let thead = table.querySelector('thead');
                                      if (!thead) {
                                          thead = document.createElement('thead');
                                          table.insertBefore(thead, table.firstChild);
                                      }
       
                                      const headerRow = table.rows[headerRowIndex];
                                      thead.appendChild(headerRow.cloneNode(true));
                                  }
       
                                  // Alignment processing
                                  const cells = document.querySelectorAll('td');
                                  cells.forEach(cell => {
                                      const content = cell.textContent.trim();
       
                                      if (content.includes('येणे') ||
                                          content.includes('Opening Balance') ||
                                          content.match(/^\\d+\\s+येणे$/) ||
                                          content.includes('Balance C/F') ||
                                          content.includes('Total')) {
                                          cell.style.textAlign = 'right';
                                          cell.classList.add('balance-value');
                                      }
       
                                      const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                      if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                          cell.style.textAlign = 'right';
                                          cell.classList.add('amount');
                                      }
       
                                      cell.style.border = '1px solid black';
                                  });
       
                                  setTimeout(() => {
                                      window.print();
                                      setTimeout(() => { window.close(); }, 500);
                                  }, 200);
                              };
                           </script>
                       </body>
                   </html>
               `);
               printWindow.document.close();
           } else {
               console.error("Failed to open print window.");
           }
       }
 
 }
 